export const rankingOptionScale = [
  {value: 0, label: 'Mai o quasi mai', labelKey: 'RANKING_OPTION_SCALE_0'},
  {value: 1, label: 'Principiante', labelKey: 'RANKING_OPTION_SCALE_1'},
  {value: 2, label: 'Intermedio basso', labelKey: 'RANKING_OPTION_SCALE_2'},
  {value: 3, label: 'Intermedio alto', labelKey: 'RANKING_OPTION_SCALE_3'},
  {value: 4, label: 'Avanzato', labelKey: 'RANKING_OPTION_SCALE_4'}
];

const experienceOptions = {
  tennis: [
    {value: 0, label: 'Ho appena iniziato', labelKey: 'RANKING_EXP_TENNIS_0'},
    {value: 1, label: 'Meno di 1 anno', labelKey: 'RANKING_EXP_TENNIS_1'},
    {value: 2, label: '1-3 anni', labelKey: 'RANKING_EXP_TENNIS_2'},
    {value: 3, label: '3-6 anni', labelKey: 'RANKING_EXP_TENNIS_3'},
    {value: 4, label: 'Oltre 6 anni', labelKey: 'RANKING_EXP_TENNIS_4'}
  ],
  padel: [
    {value: 0, label: 'Prime partite', labelKey: 'RANKING_EXP_PADEL_0'},
    {value: 1, label: 'Meno di 6 mesi', labelKey: 'RANKING_EXP_PADEL_1'},
    {value: 2, label: '6 mesi - 2 anni', labelKey: 'RANKING_EXP_PADEL_2'},
    {value: 3, label: '2-4 anni', labelKey: 'RANKING_EXP_PADEL_3'},
    {value: 4, label: 'Oltre 4 anni', labelKey: 'RANKING_EXP_PADEL_4'}
  ],
  pickleball: [
    {value: 0, label: 'Prime partite', labelKey: 'RANKING_EXP_PICKLEBALL_0'},
    {value: 1, label: 'Meno di 3 mesi', labelKey: 'RANKING_EXP_PICKLEBALL_1'},
    {value: 2, label: '3-12 mesi', labelKey: 'RANKING_EXP_PICKLEBALL_2'},
    {value: 3, label: '1-3 anni', labelKey: 'RANKING_EXP_PICKLEBALL_3'},
    {value: 4, label: 'Oltre 3 anni', labelKey: 'RANKING_EXP_PICKLEBALL_4'}
  ]
};

const frequencyOptions = [
  {value: 0, label: 'Occasionalmente', labelKey: 'RANKING_FREQ_0'},
  {value: 1, label: '1 volta al mese', labelKey: 'RANKING_FREQ_1'},
  {value: 2, label: '1 volta a settimana', labelKey: 'RANKING_FREQ_2'},
  {value: 3, label: '2-3 volte a settimana', labelKey: 'RANKING_FREQ_3'},
  {value: 4, label: '4+ volte a settimana', labelKey: 'RANKING_FREQ_4'}
];

const tennisFitpOptions = [
  {value: 0, label: 'Nessuna classifica', labelKey: 'RANKING_FITP_TENNIS_0'},
  {value: 1, label: 'NC / 4.6 - 4.4', labelKey: 'RANKING_FITP_TENNIS_1'},
  {value: 2, label: '4.3 - 4.1', labelKey: 'RANKING_FITP_TENNIS_2'},
  {value: 3, label: '3.5 - 3.1', labelKey: 'RANKING_FITP_TENNIS_3'},
  {value: 4, label: '2a categoria o superiore', labelKey: 'RANKING_FITP_TENNIS_4'}
];

const tennisServeOptions = [
  {value: 0, label: 'Molti doppi falli', labelKey: 'RANKING_TENNIS_SERVE_0'},
  {value: 1, label: 'Regolare ma poco incisivo', labelKey: 'RANKING_TENNIS_SERVE_1'},
  {value: 2, label: 'Buona prima, seconda fragile', labelKey: 'RANKING_TENNIS_SERVE_2'},
  {value: 3, label: 'Servizio affidabile', labelKey: 'RANKING_TENNIS_SERVE_3'},
  {value: 4, label: 'Servizio arma importante', labelKey: 'RANKING_TENNIS_SERVE_4'}
];

const tennisBaselineOptions = [
  {value: 0, label: 'Scambi molto brevi', labelKey: 'RANKING_TENNIS_BASELINE_0'},
  {value: 1, label: 'Tengo pochi colpi', labelKey: 'RANKING_TENNIS_BASELINE_1'},
  {value: 2, label: 'Tengo ritmo medio', labelKey: 'RANKING_TENNIS_BASELINE_2'},
  {value: 3, label: 'Costruisco lo scambio', labelKey: 'RANKING_TENNIS_BASELINE_3'},
  {value: 4, label: 'Domino ritmo e profondita\'', labelKey: 'RANKING_TENNIS_BASELINE_4'}
];

const tennisNetOptions = [
  {value: 0, label: 'Evito la rete', labelKey: 'RANKING_TENNIS_NET_0'},
  {value: 1, label: 'Volee poco sicure', labelKey: 'RANKING_TENNIS_NET_1'},
  {value: 2, label: 'Chiudo palle semplici', labelKey: 'RANKING_TENNIS_NET_2'},
  {value: 3, label: 'Attacco con continuita\'', labelKey: 'RANKING_TENNIS_NET_3'},
  {value: 4, label: 'Gioco a rete decisivo', labelKey: 'RANKING_TENNIS_NET_4'}
];

const tennisMatchOptions = [
  {value: 0, label: 'Solo palleggio/lezioni', labelKey: 'RANKING_TENNIS_MATCHES_0'},
  {value: 1, label: 'Partite amichevoli rare', labelKey: 'RANKING_TENNIS_MATCHES_1'},
  {value: 2, label: 'Amichevoli regolari', labelKey: 'RANKING_TENNIS_MATCHES_2'},
  {value: 3, label: 'Tornei di circolo', labelKey: 'RANKING_TENNIS_MATCHES_3'},
  {value: 4, label: 'Tornei federali regolari', labelKey: 'RANKING_TENNIS_MATCHES_4'}
];

const padelWallOptions = [
  {value: 0, label: 'Le evito quasi sempre', labelKey: 'RANKING_PADEL_WALLS_0'},
  {value: 1, label: 'Le uso con difficolta\'', labelKey: 'RANKING_PADEL_WALLS_1'},
  {value: 2, label: 'Difendo palle semplici', labelKey: 'RANKING_PADEL_WALLS_2'},
  {value: 3, label: 'Le uso per ricostruire', labelKey: 'RANKING_PADEL_WALLS_3'},
  {value: 4, label: 'Le uso in modo tattico', labelKey: 'RANKING_PADEL_WALLS_4'}
];

const padelNetOptions = [
  {value: 0, label: 'Resto spesso a fondo', labelKey: 'RANKING_PADEL_NET_0'},
  {value: 1, label: 'Salgo ma subisco', labelKey: 'RANKING_PADEL_NET_1'},
  {value: 2, label: 'Tengo la posizione', labelKey: 'RANKING_PADEL_NET_2'},
  {value: 3, label: 'Creo pressione', labelKey: 'RANKING_PADEL_NET_3'},
  {value: 4, label: 'Comando il punto a rete', labelKey: 'RANKING_PADEL_NET_4'}
];

const padelOverheadOptions = [
  {value: 0, label: 'Non li uso', labelKey: 'RANKING_PADEL_OVERHEAD_0'},
  {value: 1, label: 'Solo colpi semplici', labelKey: 'RANKING_PADEL_OVERHEAD_1'},
  {value: 2, label: 'Bandeja regolare', labelKey: 'RANKING_PADEL_OVERHEAD_2'},
  {value: 3, label: 'Vario bandeja e vibora', labelKey: 'RANKING_PADEL_OVERHEAD_3'},
  {value: 4, label: 'Chiudo spesso dall\'alto', labelKey: 'RANKING_PADEL_OVERHEAD_4'}
];

const padelTacticsOptions = [
  {value: 0, label: 'Gioco senza strategia', labelKey: 'RANKING_PADEL_TACTICS_0'},
  {value: 1, label: 'Seguo il compagno', labelKey: 'RANKING_PADEL_TACTICS_1'},
  {value: 2, label: 'Scelgo quando attaccare', labelKey: 'RANKING_PADEL_TACTICS_2'},
  {value: 3, label: 'Gestisco ritmo e posizione', labelKey: 'RANKING_PADEL_TACTICS_3'},
  {value: 4, label: 'Leggo bene coppia e spazi', labelKey: 'RANKING_PADEL_TACTICS_4'}
];

const pickleballServeReturnOptions = [
  {value: 0, label: 'Molti errori diretti', labelKey: 'RANKING_PICKLEBALL_SERVE_RETURN_0'},
  {value: 1, label: 'Metto spesso in campo', labelKey: 'RANKING_PICKLEBALL_SERVE_RETURN_1'},
  {value: 2, label: 'Regolare con poca profondita\'', labelKey: 'RANKING_PICKLEBALL_SERVE_RETURN_2'},
  {value: 3, label: 'Profondo e affidabile', labelKey: 'RANKING_PICKLEBALL_SERVE_RETURN_3'},
  {value: 4, label: 'Creo vantaggio subito', labelKey: 'RANKING_PICKLEBALL_SERVE_RETURN_4'}
];

const pickleballKitchenOptions = [
  {value: 0, label: 'Non gestisco i dink', labelKey: 'RANKING_PICKLEBALL_KITCHEN_0'},
  {value: 1, label: 'Resto poco in controllo', labelKey: 'RANKING_PICKLEBALL_KITCHEN_1'},
  {value: 2, label: 'Tengo scambi semplici', labelKey: 'RANKING_PICKLEBALL_KITCHEN_2'},
  {value: 3, label: 'Vario ritmo e angoli', labelKey: 'RANKING_PICKLEBALL_KITCHEN_3'},
  {value: 4, label: 'Controllo spesso la kitchen', labelKey: 'RANKING_PICKLEBALL_KITCHEN_4'}
];

const pickleballThirdShotOptions = [
  {value: 0, label: 'Non li distinguo ancora', labelKey: 'RANKING_PICKLEBALL_THIRD_SHOT_0'},
  {value: 1, label: 'Provo ma sbaglio spesso', labelKey: 'RANKING_PICKLEBALL_THIRD_SHOT_1'},
  {value: 2, label: 'Scelta corretta a volte', labelKey: 'RANKING_PICKLEBALL_THIRD_SHOT_2'},
  {value: 3, label: 'Drop/drive affidabili', labelKey: 'RANKING_PICKLEBALL_THIRD_SHOT_3'},
  {value: 4, label: 'Uso il terzo colpo per comandare', labelKey: 'RANKING_PICKLEBALL_THIRD_SHOT_4'}
];

const pickleballRallyOptions = [
  {value: 0, label: 'Rally molto brevi', labelKey: 'RANKING_PICKLEBALL_RALLIES_0'},
  {value: 1, label: 'Fatico nelle transizioni', labelKey: 'RANKING_PICKLEBALL_RALLIES_1'},
  {value: 2, label: 'Tengo rally medi', labelKey: 'RANKING_PICKLEBALL_RALLIES_2'},
  {value: 3, label: 'Resetto e ricostruisco', labelKey: 'RANKING_PICKLEBALL_RALLIES_3'},
  {value: 4, label: 'Gestisco rally lunghi', labelKey: 'RANKING_PICKLEBALL_RALLIES_4'}
];

const padelFitpOptions = [
  {value: 0, label: 'Nessuna classifica', labelKey: 'RANKING_FITP_PADEL_0'},
  {value: 1, label: 'Quinta fascia / base', labelKey: 'RANKING_FITP_PADEL_1'},
  {value: 2, label: 'Quarta fascia / intermedio', labelKey: 'RANKING_FITP_PADEL_2'},
  {value: 3, label: 'Terza fascia / avanzato', labelKey: 'RANKING_FITP_PADEL_3'},
  {value: 4, label: 'Seconda/Prima fascia', labelKey: 'RANKING_FITP_PADEL_4'}
];

export const rankingQuestionLabel = (question, t) => {
  if (!question) return '';
  return question.labelKey && t ? t(question.labelKey, question.label) : question.label;
};

export const rankingOptionLabel = (option, t) => {
  if (!option) return '';
  return option.labelKey && t ? t(option.labelKey, option.label) : option.label;
};

export const playerRankingQuestionnaires = {
  tennis: {
    sport: 'tennis',
    options: rankingOptionScale,
    questions: [
      {key: 'experience', label: 'Da quanto tempo giochi a tennis?', labelKey: 'RANKING_Q_TENNIS_EXPERIENCE', options: experienceOptions.tennis},
      {key: 'frequency', label: 'Quanto spesso giochi o ti alleni?', labelKey: 'RANKING_Q_FREQUENCY', options: frequencyOptions},
      {key: 'fitp_current', label: 'Hai una classifica FITP attuale?', labelKey: 'RANKING_Q_TENNIS_FITP_CURRENT', options: tennisFitpOptions},
      {key: 'fitp_best', label: 'Qual e\' stata la tua migliore classifica FITP in carriera?', labelKey: 'RANKING_Q_TENNIS_FITP_BEST', options: tennisFitpOptions},
      {key: 'serve', label: 'Quanto e\' solido il tuo servizio?', labelKey: 'RANKING_Q_TENNIS_SERVE', options: tennisServeOptions},
      {key: 'baseline', label: 'Quanto riesci a sostenere lo scambio da fondo?', labelKey: 'RANKING_Q_TENNIS_BASELINE', options: tennisBaselineOptions},
      {key: 'net', label: 'Quanto sei efficace a rete?', labelKey: 'RANKING_Q_TENNIS_NET', options: tennisNetOptions},
      {key: 'matches', label: 'Quanta esperienza hai in partite e tornei?', labelKey: 'RANKING_Q_TENNIS_MATCHES', options: tennisMatchOptions}
    ]
  },
  padel: {
    sport: 'padel',
    options: rankingOptionScale,
    questions: [
      {key: 'experience', label: 'Da quanto tempo giochi a padel?', labelKey: 'RANKING_Q_PADEL_EXPERIENCE', options: experienceOptions.padel},
      {key: 'frequency', label: 'Quanto spesso giochi o ti alleni?', labelKey: 'RANKING_Q_FREQUENCY', options: frequencyOptions},
      {key: 'fitp_current', label: 'Hai una classifica FITP padel attuale?', labelKey: 'RANKING_Q_PADEL_FITP_CURRENT', options: padelFitpOptions},
      {key: 'fitp_best', label: 'Qual e\' stata la tua migliore classifica FITP padel?', labelKey: 'RANKING_Q_PADEL_FITP_BEST', options: padelFitpOptions},
      {key: 'walls', label: 'Quanto usi correttamente le pareti?', labelKey: 'RANKING_Q_PADEL_WALLS', options: padelWallOptions},
      {key: 'net', label: 'Quanto sei efficace nel gioco a rete?', labelKey: 'RANKING_Q_PADEL_NET', options: padelNetOptions},
      {key: 'overhead', label: 'Quanto controlli bandeja, vibora e smash?', labelKey: 'RANKING_Q_PADEL_OVERHEAD', options: padelOverheadOptions},
      {key: 'tactics', label: 'Quanto leggi le situazioni tattiche di doppio?', labelKey: 'RANKING_Q_PADEL_TACTICS', options: padelTacticsOptions}
    ]
  },
  pickleball: {
    sport: 'pickleball',
    options: rankingOptionScale,
    questions: [
      {key: 'experience', label: 'Da quanto tempo giochi a pickleball?', labelKey: 'RANKING_Q_PICKLEBALL_EXPERIENCE', options: experienceOptions.pickleball},
      {key: 'frequency', label: 'Quanto spesso giochi o ti alleni?', labelKey: 'RANKING_Q_FREQUENCY', options: frequencyOptions},
      {key: 'serve_return', label: 'Quanto sono regolari servizio e risposta?', labelKey: 'RANKING_Q_PICKLEBALL_SERVE_RETURN', options: pickleballServeReturnOptions},
      {key: 'kitchen', label: 'Quanto sei efficace nel gioco in kitchen?', labelKey: 'RANKING_Q_PICKLEBALL_KITCHEN', options: pickleballKitchenOptions},
      {key: 'third_shot', label: 'Quanto controlli third shot drop e drive?', labelKey: 'RANKING_Q_PICKLEBALL_THIRD_SHOT', options: pickleballThirdShotOptions},
      {key: 'rallies', label: 'Quanto gestisci rally, reset e transizioni?', labelKey: 'RANKING_Q_PICKLEBALL_RALLIES', options: pickleballRallyOptions}
    ]
  }
};

const isGenericRankingOptions = options => {
  if (!Array.isArray(options) || options.length !== rankingOptionScale.length) return false;
  return options.every((option, index) => option && option.label === rankingOptionScale[index].label);
};

const mergeSportQuestionnaire = (fallbackQuestionnaire, remoteQuestionnaire) => {
  if (!remoteQuestionnaire || !Array.isArray(remoteQuestionnaire.questions)) {
    return fallbackQuestionnaire;
  }

  const remoteQuestions = {};
  remoteQuestionnaire.questions.forEach(question => {
    if (question && question.key) remoteQuestions[question.key] = question;
  });

  return {
    ...fallbackQuestionnaire,
    ...remoteQuestionnaire,
    options: fallbackQuestionnaire.options,
    questions: fallbackQuestionnaire.questions.map(fallbackQuestion => {
      const remoteQuestion = remoteQuestions[fallbackQuestion.key];
      if (!remoteQuestion) return fallbackQuestion;
      const remoteOptions = remoteQuestion.options || remoteQuestionnaire.options;
      return {
        ...fallbackQuestion,
        ...remoteQuestion,
        options: remoteOptions && !isGenericRankingOptions(remoteOptions) ? remoteOptions : fallbackQuestion.options
      };
    })
  };
};

export const mergeRankingQuestionnaires = questionnaires => {
  const remoteQuestionnaires = questionnaires || {};
  return Object.keys(playerRankingQuestionnaires).reduce((merged, sport) => ({
    ...merged,
    [sport]: mergeSportQuestionnaire(playerRankingQuestionnaires[sport], remoteQuestionnaires[sport])
  }), {});
};

export const upsertPlayerRanking = (rankings, updatedRanking) => {
  if (!updatedRanking || !updatedRanking.sport) return normalizePlayerRankings(rankings);
  const merged = normalizePlayerRankings(rankings);
  const index = merged.findIndex(ranking => ranking.sport === updatedRanking.sport);
  if (index >= 0) {
    merged[index] = {...merged[index], ...updatedRanking};
  } else {
    merged.push(updatedRanking);
  }
  return merged;
};

export const rankingSports = ['tennis', 'padel', 'pickleball'];

export const emptyRankingForSport = sport => ({
  sport,
  configured: false,
  level: null,
  displayLevel: null,
  rating: null,
  reliability: 0,
  ratingReliability: 0,
  scaleMin: 1.0,
  scaleMax: 10.0,
  externalScale: ['tennis', 'padel', 'pickleball'].includes(sport) ? 'fitp' : 'replayer',
  externalLabel: null,
  federation: {
    federation: ['tennis', 'padel', 'pickleball'].includes(sport) ? 'FITP' : null,
    country: ['tennis', 'padel', 'pickleball'].includes(sport) ? 'IT' : null,
    licenseNumber: null,
    classification: null,
    bestClassification: null,
    status: 'not_provided',
    verified: false,
    verificationSource: null,
    verifiedAt: null
  },
  competitiveMatches: 0,
  friendlyMatches: 0,
  source: null,
  answers: []
});

export const normalizePlayerRankings = rankings => {
  const rankingMap = {};
  (rankings || []).forEach(ranking => {
    if (ranking && ranking.sport) {
      rankingMap[ranking.sport] = ranking;
    }
  });
  return rankingSports.map(sport => ({
    ...emptyRankingForSport(sport),
    ...(rankingMap[sport] || {})
  }));
};
